<template>
    <ValidationProvider tag="div" :rules="rules" :name="field.labelSC" :vid="field.id" v-slot="{ validate, errors }">
        <div>
            <button>Browse...</button>
            <input type="file"
                   :name="field.handle+'[]'"
                   :id="field.id"
                   :required="field.required"
                   :placeholder="field.placeholder"
                   :multiple="field.file.multiple"
                   v-bind="attributes"
                   @change="fakePlaceholder($event, validate)"
            />
        </div>
        <small class="error">{{ errors[0] }}</small>
    </ValidationProvider>
</template>

<script>
    import Helper from "../Helper";

    export default {
        props: {
            field: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                attributes: {},
                rules: {
                    required: this.field.required,
                    size: this.field.file.size,
                }
            }
        },
        methods: {
            fakePlaceholder: function(e, callback) {
                let parentQS = '.field-type-file.field-handle-' + this.field.handle+' div>div::after';

                if(e.target.files[0]) {
                    window.setPseudoElContent(parentQS, e.target.files[0].name);
                } else {
                    window.setPseudoElContent(parentQS, false);
                }

                callback(e);
            },
        },
        mounted() {
            this.attributes = Helper.setupAttributes(this.attributes, this.field.inputAttributes);
        }
    }
</script>